module.exports = __webpack_public_path__ + "static/media/code-icon-active.e6ff43cc.svg";